import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import styles from "./ExpandableFieldErrors.module.css";
export var ExpandableFieldErrors = function (_a) {
    var errors = _a.errors;
    var _b = useState(false), expanded = _b[0], setExpanded = _b[1];
    if (!errors || errors.length === 0) {
        return undefined;
    }
    if (errors.length === 1) {
        return errors[0];
    }
    if (!expanded) {
        return (React.createElement("span", null,
            errors[0],
            React.createElement("button", { type: "button", className: styles.toggle, onClick: function () { return setExpanded(true); } },
                React.createElement(FormattedMessage, { id: "ui-br-agency.error.field.showMore", values: { count: errors.length - 1 } }))));
    }
    return (React.createElement("span", null,
        React.createElement("ul", { className: styles.errorList }, errors.map(function (error, index) { return (React.createElement("li", { key: index }, error)); })),
        React.createElement("button", { type: "button", className: styles.toggle, onClick: function () { return setExpanded(false); } },
            React.createElement(FormattedMessage, { id: "ui-br-agency.error.field.showLess" }))));
};
